import { render, staticRenderFns } from "./qitayongyao.vue?vue&type=template&id=caa06c7a&scoped=true"
import script from "./qitayongyao.vue?vue&type=script&lang=ts"
export * from "./qitayongyao.vue?vue&type=script&lang=ts"
import style0 from "./qitayongyao.vue?vue&type=style&index=0&id=caa06c7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa06c7a",
  null
  
)

export default component.exports